import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();
  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('If the email exists, a reset link has been sent');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F8FAFC' }}>
      <Card className="w-full max-w-md p-8">
        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: '#1E3A8A' }}>OctoBoots</h1>
        <p className="text-slate-600 mb-6">Forgot Password</p>
        {sent ? (
          <div className="space-y-4">
            <p className="text-slate-700">Check your email for the reset link.</p>
            <Button onClick={() => navigate('/login')} className="w-full" style={{ backgroundColor: '#1E3A8A' }}>Back to Login</Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full" style={{ backgroundColor: '#1E3A8A' }}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
            <Button variant="link" onClick={() => navigate('/login')} type="button" className="w-full">Back to Login</Button>
          </form>
        )}
      </Card>
    </div>
  );
};
